import { render, staticRenderFns } from "./AudioPlayerComponent.vue?vue&type=template&id=44abe8a2&scoped=true&"
import script from "./AudioPlayerComponent.vue?vue&type=script&lang=js&"
export * from "./AudioPlayerComponent.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlayerComponent.vue?vue&type=style&index=0&id=44abe8a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44abe8a2",
  null
  
)

export default component.exports